<section class="start-page" id="main">
  <div class="start-page__top-bar">
    <app-toolbar />
  </div>

  <div class="start-page__logo-stage">
    <app-interactive-logo />
  </div>

  <div class="start-page__scroll" aria-hidden="true">
    <span class="start-page__scroll-text">Scroll</span>
    <span class="start-page__scroll-arrow"></span>
  </div>
</section>
